import { Component, OnInit, Input } from '@angular/core';
import { AccountClientDetailsService } from '../../../service/account-client-edit/account-client-details.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DialogService } from 'ng2-bootstrap-modal';
import { OrdersModalComponent } from './orders-modal/orders-modal.component';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {

  @Input('clientID') clientID = '';
  @Input('search') search = '';

  //UID to control accordions
  private uid;

  //Sotre Permissions
  private permissoes = [];

  //Search Control
  private isSearch = false;

  //Search Form
  private orderSearch: FormGroup;

  //Orders arrays.
  private ordersPrazo = [];
  private ordersVista = [];
  private ordersRetira = [];

  //Count Control
  private currentPagePrazo = 0;
  private currentPageVista = 0;
  private currentPageRetira = 0;

  //Page Control
  private resultCountPrazo;
  private resultCountVista;
  private resultCountRetira;

  //Sort Control
  private sortPrazo = "asc";
  private sortVista = "asc";
  private sortRetira = "asc";

  //OrderBy Control
  private orderByPrazo = "DataRemessa";
  private orderByVista = "DataRemessa";
  private orderByRetira = "DataRemessa";

  //Selection arrays.
  private selectedOrdersPrazo = [];
  private selectedOrdersVista = [];
  private selectedOrdersRetira = [];

  private selectedOrdersPrazoCarregamento = [];
  private selectedOrdersVistaCarregamento = [];
  private selectedOrdersRetiraCarregamento = [];

  //Totals Array
  private orderTotals = [];

  //Expanded Control
  private expandedPrazo = false;
  private expandedVista = false;
  private expandedRetira = false;

  //Button Control
  private canRelease = false;
  private canBlock = false;

  private canReleaseCarregamentoPrazo = false;
  private canBlockCarregamentoPrazo = false;

  private canReleaseCarregamentoVista = false;
  private canBlockCarregamentoVista = false;

  private canReleaseCarregamentoRetira = false;
  private canBlockCarregamentoRetira = false;


  constructor(private accountClientDetailsService: AccountClientDetailsService,
    private flashMessagesService: FlashMessagesService,
    private fb: FormBuilder,
    private dialogService: DialogService) { }

  ngOnInit() {
    this.orderSearch = this.fb.group({
      OrdemVendaNumero: ''
    });

    this.getClientTotals();

    this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];

    if (this.search) {
      this.orderSearch.controls.OrdemVendaNumero.setValue(this.search);
      this.currentPagePrazo = 0;
      this.currentPageVista = 0;
      this.currentPageRetira = 0;
      this.isSearch = true;
      this.selectedOrdersPrazo = [];
      this.selectedOrdersVista = [];
      this.selectedOrdersRetira = [];
      this.selectedOrdersPrazoCarregamento = [];
      this.selectedOrdersVistaCarregamento = [];
      this.selectedOrdersRetiraCarregamento = [];
      this.getClientOrdersPrazo();
      this.getClientOrdersVista();
      this.getClientOrdersRetira();
      this.expandedPrazo = true;
      this.expandedVista = true;
      this.expandedRetira = true;
    }

    this.uid = 'ov' + this.clientID.substring(0, 5);
  }

  getClientTotals() {
    this.accountClientDetailsService.getClientTotals(this.clientID).subscribe(result => {
      this.orderTotals = result.Result ? result.Result : [];
      console.log("TOTALS", result);
    }, error => {
      this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
    });
  }

  searchOrders(search) {
    this.currentPagePrazo = 0;
    this.currentPageVista = 0;
    this.currentPageRetira = 0;
    this.isSearch = true;
    this.search = search.OrdemVendaNumero;
    this.selectedOrdersPrazo = [];
    this.selectedOrdersVista = [];
    this.selectedOrdersRetira = [];
    this.selectedOrdersPrazoCarregamento = [];
    this.selectedOrdersVistaCarregamento = [];
    this.selectedOrdersRetiraCarregamento = [];
    this.getClientOrdersPrazo();
    this.getClientOrdersVista();
    this.getClientOrdersRetira();
    this.expandedPrazo = true;
    this.expandedVista = true;
    this.expandedRetira = true;
  }

  getClientOrdersPrazo() {
    this.accountClientDetailsService.getAccountClientOrdersPrazo(this.clientID, this.search, this.orderByPrazo, this.sortPrazo, this.currentPagePrazo).subscribe(result => {
      if (result.Success) {
        this.ordersPrazo = result.Result ? result.Result : [];
        this.resultCountPrazo = result.Count;
        this.ordersPrazo.forEach(order => {
          this.selectedOrdersPrazo.forEach(selectedOrder => {
            if (order.OrdemVendaNumero == selectedOrder.OrdemVendaNumero && order.ItemOrdemVendaItem == selectedOrder.ItemOrdemVendaItem && (order.Divisao == selectedOrder.Divisao || order.FaturamentoAntecipado == true)) {
              order.checked = true;
            }
          });
          this.selectedOrdersPrazoCarregamento.forEach(selectedOrder => {
            if (JSON.stringify(order) === JSON.stringify(selectedOrder)) {
              order.bloqueioChecked = true;
            }
          });
        });
        this.shouldMarkAll();
        this.buttonPermissionCheck();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  getClientOrdersVista() {
    this.accountClientDetailsService.getAccountClientOrdersVista(this.clientID, this.search, this.orderByVista, this.sortVista, this.currentPageVista).subscribe(result => {
      if (result.Success) {
        // $('.select-all').prop('checked', false);
        this.ordersVista = result.Result ? result.Result : [];
        this.resultCountVista = result.Count;
        this.ordersVista.forEach(order => {
          this.selectedOrdersVistaCarregamento.forEach(selectedOrder => {
            if (JSON.stringify(order) === JSON.stringify(selectedOrder)) {
              order.bloqueioChecked = true;
            }
          });
        });
        this.buttonPermissionCheck();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  getClientOrdersRetira() {
    this.accountClientDetailsService.getAccountClientOrdersRetira(this.clientID, this.search, this.orderByRetira, this.sortRetira, this.currentPageRetira).subscribe(result => {
      if (result.Success) {
        this.ordersRetira = result.Result ? result.Result : [];
        this.resultCountRetira = result.Count;
        this.ordersRetira.forEach(order => {
          this.selectedOrdersRetiraCarregamento.forEach(selectedOrder => {
            if (JSON.stringify(order) === JSON.stringify(selectedOrder)) {
              order.bloqueioChecked = true;
            }
          });
        });
        this.buttonPermissionCheck();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  setOrderPrazo(orderby) {
    if (this.orderByPrazo != orderby) {
      this.sortPrazo = "asc";
    } else {
      this.sortPrazo = this.sortPrazo == "asc" ? "desc" : "asc";
    }
    this.orderByPrazo = this.orderByPrazo != orderby ? orderby : this.orderByPrazo;
    this.selectedOrdersPrazo = [];
    this.getClientOrdersPrazo();
  }

  setOrderVista(orderby) {
    if (this.orderByVista != orderby) {
      this.sortVista = "asc";
    } else {
      this.sortVista = this.sortVista == "asc" ? "desc" : "asc";
    }
    this.orderByVista = this.orderByVista != orderby ? orderby : this.orderByVista;
    this.getClientOrdersVista();
  }

  setOrderRetira(orderby) {
    if (this.orderByRetira != orderby) {
      this.sortRetira = "asc";
    } else {
      this.sortRetira = this.sortRetira == "asc" ? "desc" : "asc";
    }
    this.orderByRetira = this.orderByRetira != orderby ? orderby : this.orderByRetira;
    this.getClientOrdersRetira();
  }

  paginar($event: any, type) {
    if (type === 'prazo') {
      this.currentPagePrazo = $event;
      this.getClientOrdersPrazo();
    }

    if (type === 'vista') {
      this.currentPageVista = $event;
      this.getClientOrdersVista();
    }

    if (type === 'retira') {
      this.currentPageRetira = $event;
      this.getClientOrdersRetira();
    }
  }

  expandOrderPrazo() {
    if (!this.expandedPrazo) {
      this.getClientOrdersPrazo();
      this.expandedPrazo = true;
    }
  }

  expandOrderVista() {
    if (!this.expandedVista) {
      this.getClientOrdersVista();
      this.expandedVista = true;
    }
  }

  expandOrderRetira() {
    if (!this.expandedRetira) {
      this.getClientOrdersRetira();
      this.expandedRetira = true;
    }
  }

  shouldMarkAll() {
    $('.select-all').prop('checked', this.ordersPrazo.every(p => p.checked));
  }

  selectAll(e) {
    console.log(e.target.checked);

    if (e.target.checked) {
      this.ordersPrazo.forEach((item, index) => {
        // item.checked = true;
        this.selectOrder(index, true);
      });
    } else {
      this.ordersPrazo.forEach((item, index) => {
        // item.checked = false;
        this.selectOrder(index, false);
      });
    }
  }

  liberarOrder() {
    let tempObj = [];
    let total = 0;

    this.selectedOrdersPrazo.forEach(item => {
      tempObj.push({
        Divisao: item.FaturamentoAntecipado ? 0 : item.Divisao,
        ItemOrdemVenda: item.ItemOrdemVendaItem,
        OrdemVendaNumero: item.OrdemVendaNumero,
      });

      total += item.ValorSaldo;
    });

    this.dialogService.addDialog(OrdersModalComponent, { orderList: tempObj, clientID: this.clientID, total: total }, { backdropColor: 'rgba(0, 0, 0, 0.5)' }).subscribe((isConfirmed) => {
      if (isConfirmed) {
        this.flashMessagesService.show("Liberação solicitada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
        this.selectedOrdersPrazo = [];
        this.getClientOrdersPrazo();
      } else {
        // Do nothing...
      }
    });
  }

  bloquearOrder() {
    let tempObj = [];

    this.selectedOrdersPrazo.forEach(item => {
      tempObj.push({
        Divisao: item.Divisao,
        ItemOrdemVenda: item.ItemOrdemVendaItem,
        OrdemVendaNumero: item.OrdemVendaNumero
      });
    });

    const tempObj2 = {
      Ordens: tempObj,
      ContaClienteID: this.clientID
    };

    this.accountClientDetailsService.blockOrder(tempObj2).subscribe(result => {
      if (result.Success) {
        this.flashMessagesService.show("Divisão bloqueada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
        this.selectedOrdersPrazo = [];
        this.getClientOrdersPrazo();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  liberarCarregamentoPrazo() {
    let tempObj = [];
    let total = 0;

    this.selectedOrdersPrazoCarregamento.forEach(item => {
      tempObj.push({
        Numero: item.OrdemVendaNumero,
        Item: item.ItemOrdemVendaItem,
        Divisao: item.Divisao
      });
    });

    this.accountClientDetailsService.releaseOrderCarregamento(tempObj).subscribe(result => {
      if (result.Success) {
        this.flashMessagesService.show("Ordens liberadas para carregamento com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
        this.selectedOrdersPrazoCarregamento = [];
        this.canBlockCarregamentoPrazo = false;
        this.canReleaseCarregamentoPrazo = false;
        this.getClientOrdersPrazo();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  bloquearCarregamentoPrazo() {
    let tempObj = [];
    let total = 0;

    this.selectedOrdersPrazoCarregamento.forEach(item => {
      tempObj.push({
        Numero: item.OrdemVendaNumero,
        Item: item.ItemOrdemVendaItem,
        Divisao: item.Divisao
      });
    });

    this.accountClientDetailsService.blockOrderCarregamento(tempObj).subscribe(result => {
      if (result.Success) {
        this.flashMessagesService.show("Ordens bloqueadas para carregamento com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
        this.selectedOrdersPrazoCarregamento = [];
        this.canBlockCarregamentoPrazo = false;
        this.canReleaseCarregamentoPrazo = false;
        this.getClientOrdersPrazo();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  liberarCarregamentoVista() {
    let tempObj = [];
    let total = 0;

    this.selectedOrdersVistaCarregamento.forEach(item => {
      tempObj.push({
        Numero: item.OrdemVendaNumero,
        Item: item.ItemOrdemVendaItem,
        Divisao: item.Divisao
      });
    });

    this.accountClientDetailsService.releaseOrderCarregamento(tempObj).subscribe(result => {
      if (result.Success) {
        this.flashMessagesService.show("Ordens liberadas para carregamento com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
        this.selectedOrdersVistaCarregamento = [];
        this.canBlockCarregamentoVista = false;
        this.canReleaseCarregamentoVista = false;
        this.getClientOrdersVista();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  bloquearCarregamentoVista() {
    let tempObj = [];
    let total = 0;

    this.selectedOrdersVistaCarregamento.forEach(item => {
      tempObj.push({
        Numero: item.OrdemVendaNumero,
        Item: item.ItemOrdemVendaItem,
        Divisao: item.Divisao
      });
    });

    this.accountClientDetailsService.blockOrderCarregamento(tempObj).subscribe(result => {
      if (result.Success) {
        this.flashMessagesService.show("Ordens bloqueadas para carregamento com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
        this.selectedOrdersVistaCarregamento = [];
        this.canBlockCarregamentoVista = false;
        this.canReleaseCarregamentoVista = false;
        this.getClientOrdersVista();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  liberarCarregamentoRetira() {
    let tempObj = [];
    let total = 0;

    this.selectedOrdersRetiraCarregamento.forEach(item => {
      tempObj.push({
        Numero: item.OrdemVendaNumero,
        Item: item.ItemOrdemVendaItem,
        Divisao: item.Divisao
      });
    });

    this.accountClientDetailsService.releaseOrderCarregamento(tempObj).subscribe(result => {
      if (result.Success) {
        this.flashMessagesService.show("Ordens liberadas para carregamento com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
        this.selectedOrdersRetiraCarregamento = [];
        this.canBlockCarregamentoRetira = false;
        this.canReleaseCarregamentoRetira = false;
        this.getClientOrdersRetira();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  bloquearCarregamentoRetira() {
    let tempObj = [];
    let total = 0;

    this.selectedOrdersRetiraCarregamento.forEach(item => {
      tempObj.push({
        Numero: item.OrdemVendaNumero,
        Item: item.ItemOrdemVendaItem,
        Divisao: item.Divisao
      });
    });

    this.accountClientDetailsService.blockOrderCarregamento(tempObj).subscribe(result => {
      if (result.Success) {
        this.flashMessagesService.show("Ordens bloqueadas para carregamento com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
        this.selectedOrdersRetiraCarregamento = [];
        this.canBlockCarregamentoRetira = false;
        this.canReleaseCarregamentoRetira = false;
        this.getClientOrdersRetira();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  selectOrder(index, status) {
    // index = índice da divisão de remessa dentro do vetor ordersPrazo[]
    // status = true (checked), false (not checked)

    // Pega a divisão que está na tela e marca / desmarca de acordo com o status recebido.
    var dr = this.ordersPrazo[index];
    dr.checked = status;

    console.log("ORDENS SELECIONADAS ANTES:", this.selectedOrdersPrazo);

    // Encontra o índice da divisão de remessa selecionada dentro do vetor de divisões selecionadas.
    const tempIndex = this.selectedOrdersPrazo.findIndex(item => (item.OrdemVendaNumero == dr.OrdemVendaNumero && item.ItemOrdemVendaItem == dr.ItemOrdemVendaItem && item.Divisao == dr.Divisao));

    if (!dr.FaturamentoAntecipado) { // Ordens comuns
      if (tempIndex === -1) { // Indice não encontrado, adiciona à lista.
        if (dr.checked) {
          this.selectedOrdersPrazo.push(dr);
        }
      }
      else { // Indice encontrado, se status == false devemos remove-lo da lista.
        var dr = this.selectedOrdersPrazo[tempIndex];
        dr.checked = status;
        if (!dr.checked) {
          this.selectedOrdersPrazo.splice(tempIndex, 1);
        }
      }
    }
    else { // Ordens de faturamento antecipado
      if (tempIndex === -1) { // Indice não encontrado, adiciona todas as divisões que pertencem a mesma OV/Item à lista.
        var drsItem = this.ordersPrazo.filter(op => op.OrdemVendaNumero == dr.OrdemVendaNumero && op.ItemOrdemVendaItem == dr.ItemOrdemVendaItem);
        drsItem.forEach(d => {
          d.checked = status;
          if (d.checked) {
            this.selectedOrdersPrazo.push(d);
          }
        });
      }
      else { // Indice encontrado, se status == false devemos remover todas as divisões que pertencem a mesma OV/Item da lista.
        var drsItem = this.selectedOrdersPrazo.filter(op => op.OrdemVendaNumero == dr.OrdemVendaNumero && op.ItemOrdemVendaItem == dr.ItemOrdemVendaItem);
        drsItem.forEach(d => {
          d.checked = status;
          if (!d.checked) {
            this.selectedOrdersPrazo = this.selectedOrdersPrazo.filter(op => !(op.OrdemVendaNumero == dr.OrdemVendaNumero && op.ItemOrdemVendaItem == dr.ItemOrdemVendaItem));
          }
        });
      }
    }

    console.log("ORDENS SELECIONADAS DEPOIS:", this.selectedOrdersPrazo);

    this.shouldMarkAll();
    this.buttonPermissionCheck();
  }

  selectCarregamentoOrderPrazo(index) {
    const tempIndex = this.selectedOrdersPrazoCarregamento.findIndex(item => (item.OrdemVendaNumero == this.ordersPrazo[index].OrdemVendaNumero && item.ItemOrdemVendaItem == this.ordersPrazo[index].ItemOrdemVendaItem && item.Divisao == this.ordersPrazo[index].Divisao));

    if (tempIndex === -1) {
      this.selectedOrdersPrazoCarregamento.push(this.ordersPrazo[index]);
      //console.log("HERE >>",this.selectedOrdersPrazo)
    } else {
      this.selectedOrdersPrazoCarregamento.splice(tempIndex, 1);
      //console.log("HERE >>",this.selectedOrdersPrazo)
    }

    this.buttonPermissionCheck();
  }

  selectCarregamentoOrderVista(index) {
    const tempIndex = this.selectedOrdersVistaCarregamento.findIndex(item => (item.OrdemVendaNumero == this.ordersVista[index].OrdemVendaNumero && item.ItemOrdemVendaItem == this.ordersVista[index].ItemOrdemVendaItem && item.Divisao == this.ordersVista[index].Divisao));

    if (tempIndex === -1) {
      this.selectedOrdersVistaCarregamento.push(this.ordersVista[index]);
      //console.log("HERE >>",this.selectedOrdersPrazo)
    } else {
      this.selectedOrdersVistaCarregamento.splice(tempIndex, 1);
      //console.log("HERE >>",this.selectedOrdersPrazo)
    }

    this.buttonPermissionCheck();
  }

  selectCarregamentoOrderRetira(index) {
    const tempIndex = this.selectedOrdersRetiraCarregamento.findIndex(item => (item.OrdemVendaNumero == this.ordersRetira[index].OrdemVendaNumero && item.ItemOrdemVendaItem == this.ordersRetira[index].ItemOrdemVendaItem && item.Divisao == this.ordersRetira[index].Divisao));

    if (tempIndex === -1) {
      this.selectedOrdersRetiraCarregamento.push(this.ordersRetira[index]);
      //console.log("HERE >>",this.selectedOrdersPrazo)
    } else {
      this.selectedOrdersRetiraCarregamento.splice(tempIndex, 1);
      //console.log("HERE >>",this.selectedOrdersPrazo)
    }

    this.buttonPermissionCheck();
  }

  buttonPermissionCheck() {
    if (this.selectedOrdersPrazo) {
      const tempIndexBloq = this.selectedOrdersPrazo.findIndex(item => (item.BloqueioPortal == 'OB' || item.BloqueioPortal == 'BM'));
      const tempIndexLib = this.selectedOrdersPrazo.findIndex(item => (item.BloqueioPortal == 'OL' || item.BloqueioPortal == 'LM'));

      if ((tempIndexBloq != -1 && tempIndexLib != -1) || (tempIndexBloq == -1 && tempIndexLib == -1)) {
        this.canRelease = false;
        this.canBlock = false;
      }

      if (tempIndexBloq != -1 && tempIndexLib == -1) {
        this.canRelease = true;
        this.canBlock = false;
      }

      if (tempIndexBloq == -1 && tempIndexLib != -1) {
        this.canRelease = false;
        this.canBlock = true;
      }
    }

    if (this.selectedOrdersPrazoCarregamento) {
      const tempIndexCarregBloqPrazo = this.selectedOrdersPrazoCarregamento.findIndex(item => (item.BloqueioCarregamento == true));
      const tempIndexCarregLibPrazo = this.selectedOrdersPrazoCarregamento.findIndex(item => (item.BloqueioCarregamento == false));

      this.canBlockCarregamentoPrazo = tempIndexCarregLibPrazo != -1 && tempIndexCarregBloqPrazo == -1
      this.canReleaseCarregamentoPrazo = tempIndexCarregLibPrazo == -1 && tempIndexCarregBloqPrazo != -1
    }

    if (this.selectedOrdersVistaCarregamento) {
      const tempIndexCarregBloqVista = this.selectedOrdersVistaCarregamento.findIndex(item => (item.BloqueioCarregamento == true));
      const tempIndexCarregLibVista = this.selectedOrdersVistaCarregamento.findIndex(item => (item.BloqueioCarregamento == false));

      this.canBlockCarregamentoVista = tempIndexCarregLibVista != -1 && tempIndexCarregBloqVista == -1
      this.canReleaseCarregamentoVista = tempIndexCarregLibVista == -1 && tempIndexCarregBloqVista != -1
    }

    if (this.selectedOrdersRetiraCarregamento) {
      const tempIndexCarregBloqRetira = this.selectedOrdersRetiraCarregamento.findIndex(item => (item.BloqueioCarregamento == true));
      const tempIndexCarregLibRetira = this.selectedOrdersRetiraCarregamento.findIndex(item => (item.BloqueioCarregamento == false));

      this.canBlockCarregamentoRetira = tempIndexCarregLibRetira != -1 && tempIndexCarregBloqRetira == -1
      this.canReleaseCarregamentoRetira = tempIndexCarregLibRetira == -1 && tempIndexCarregBloqRetira != -1
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/orders/orders.component.ts